import {
  IconGrid,
  IconCal,
  IconLunch,
  IconMail,
  IconFund,
  IconUsers,
  IconRoomParents,
  IconLink,
  IconConsent,
  IconTodo,
} from '../components/icons';

export const PATHS = {
  LOGIN: '/login',
  VERIFY: '/verify',
  SIGNUP: '/signup',
  DASHBOARD: '/dashboard',
  CALENDAR: '/calendar',
  SIGNUPS: '/sign-ups',
  LINKS: '/links',
  /* Reached from the Links hub rather than the sidebar, like SIGNUPS */
  REMINDERS: '/reminders',
  DONATION_LINKS: '/donation-links',
  USERS: '/users',
  EMAIL: '/compose-email',
  FUNDRAISING: '/fundraising',
  LUNCH: '/lunch-menu',
  ROOM_PARENTS: '/room-parents',
  CONSENT: '/consent-forms',
  TODOS: '/to-dos',
  PROFILE: '/profile',
};

/* The sidebar shows every item in order. On a phone only `primary` items get a
   slot in the bottom tab bar — the rest move into the More sheet — and `short`
   is the label that fits there. */
export const CLASS_NAV = [
  { path: PATHS.DASHBOARD, label: 'Dashboard', Icon: IconGrid, primary: true },
  { path: PATHS.EMAIL, label: 'Compose Email', short: 'Email', Icon: IconMail, primary: true },
  { path: PATHS.USERS, label: 'Parents', Icon: IconUsers },
  { path: PATHS.CALENDAR, label: 'Calendar', Icon: IconCal, primary: true },
  { path: PATHS.LINKS, label: 'Links', Icon: IconLink },
  { path: PATHS.FUNDRAISING, label: 'Fundraising', short: 'Funds', Icon: IconFund, primary: true },
  { path: PATHS.CONSENT, label: 'Consent Forms', Icon: IconConsent },
  { path: PATHS.TODOS, label: 'Room Parent To-Do', short: 'To-Do', Icon: IconTodo },
];

export const MASTER_NAV = [
  { path: PATHS.DASHBOARD, label: 'Dashboard', Icon: IconGrid, primary: true },
  { path: PATHS.CALENDAR, label: 'Master Calendar', short: 'Calendar', Icon: IconCal, primary: true },
  { path: PATHS.LUNCH, label: 'Lunch Menu', short: 'Lunch', Icon: IconLunch, primary: true },
  /* "Directory" on a school (Mohit, 30 Sep) — the page behind it is still the
     Room Parents & Activity one */
  { path: PATHS.ROOM_PARENTS, label: 'Directory', Icon: IconRoomParents, primary: true },
];

export const navForContext = (ctx) => (ctx.type === 'master' ? MASTER_NAV : CLASS_NAV);

/* Bottom bar vs More sheet. A master context has few enough sections that they
   all fit, so its More button never appears. */
export const tabNavForContext = (ctx) => navForContext(ctx).filter((n) => n.primary);
export const moreNavForContext = (ctx) => navForContext(ctx).filter((n) => !n.primary);
